/**
 * reducers/index.js
 */

export { default as contact } from './contact'
export { default as login } from './login'
export { default as recruit } from './recruit'

export const noop = (state = {}) => state;


// WEBPACK FOOTER //
// ./src/reducers/index.js